import { render, staticRenderFns } from "./UrunTanimla.vue?vue&type=template&id=9915b234&scoped=true&"
import script from "./UrunTanimla.vue?vue&type=script&lang=js&"
export * from "./UrunTanimla.vue?vue&type=script&lang=js&"
import style0 from "./UrunTanimla.vue?vue&type=style&index=0&id=9915b234&scoped=true&lang=css&"
import style1 from "./UrunTanimla.vue?vue&type=style&index=1&id=9915b234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9915b234",
  null
  
)

export default component.exports